import React from 'react'
import styled from 'styled-components'
import { screenSize } from '../../config/screens.config'
import { css } from 'styled-components'
import * as UMEColors from '@bit/ume.design-kit.ui/utils/_colors'

export const FinancialTab = (props: any) => {
  let { Icon, active, title } = props

  return (
    <Tab active={active} {...props}>
      <Icon />
      <Label>{title}</Label>
    </Tab>
  )
}

const Tab = styled.div`
  display: flex;
  flex: 1 1 100px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 2px solid black;
  margin: 10px 0px 0px 0px;
  padding-bottom: 3px;
  max-width: 225px;
  height: 34px;

  color: ${UMEColors.black.primary};

  &:hover {
    cursor: pointer;
    border-width: 4px;
    transition: 250ms;
    opacity: 1;
  }

  ${(props: any) =>
    props.active &&
    css`
      opacity: 0.2;
      cursor: pointer;
    `}

  &:nth-child(even) {
    margin-left: 32px;
  }

  @media ${screenSize.mobileL} {
    &:nth-child(even) {
      margin-left: 0px;
    }
  }
`

const Label = styled.span`
  margin-left: 16px;
  font-family: 'Roboto';
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.69px;
  line-height: 25px;
  text-align: center;
`
